export const GET_CONCEPT_BY_UUID = "GET_CONCEPT_BY_UUID";
export const GET_ALL_CONCEPTS = "GET_ALL_CONCEPTS";
export const SET_PROJECT_CONCEPT = "SET_PROJECT_CONCEPT";
